import { render } from "./PostPageWithStore.vue?vue&type=template&id=89fd91fc"
import script from "./PostPageWithStore.vue?vue&type=script&lang=js"
export * from "./PostPageWithStore.vue?vue&type=script&lang=js"

import "./PostPageWithStore.vue?vue&type=style&index=0&id=89fd91fc&lang=css"

import exportComponent from "D:\\secret\\py\\main_bot\\bank-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__